import { render, staticRenderFns } from "./userSelect.vue?vue&type=template&id=906c36de&scoped=true&"
import script from "./userSelect.vue?vue&type=script&lang=js&"
export * from "./userSelect.vue?vue&type=script&lang=js&"
import style0 from "./userSelect.vue?vue&type=style&index=0&id=906c36de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906c36de",
  null
  
)

export default component.exports